import { Field as SlsField, FieldProps, Select } from 'ui';
import { Field, FieldConfig, FieldProps as FormikFieldProps } from 'formik';
import React from 'react';

export type FormikSelectFieldProps = Omit<FieldProps, 'name'> &
  Omit<FieldConfig, 'value'> & {
    selectProps?: Omit<
      React.SelectHTMLAttributes<HTMLSelectElement>,
      'id' | 'name' | 'placeholder'
    >;
  };

export const FormikSelectField: React.FC<FormikSelectFieldProps> = ({
  className,
  children,
  id,
  name,
  placeholder,
  selectProps,
  ...props
}) => (
  <Field name={name}>
    {({ field, meta }: FormikFieldProps) => (
      <SlsField {...props} id={id} name={name} error={meta.error}>
        <Select
          {...field}
          {...selectProps}
          className={className}
          id={id || name}
          name={name}
          error={!!meta.error}
          placeholder={placeholder}
        >
          {children}
        </Select>
      </SlsField>
    )}
  </Field>
);
